module.exports = __webpack_public_path__ + "assets/gear.7f22c074.svg";